import { Database } from 'lucide-react';
import { CollapsibleSection } from '../ui/CollapsibleSection';

export function MetadataPanel({ metadata }: { metadata: Record<string, unknown> }) {
  const json = JSON.stringify(metadata, null, 2);
  const keyCount = Object.keys(metadata ?? {}).length;
  return (
    <CollapsibleSection
      icon={<Database className="h-4 w-4 text-fg-muted" />}
      title="Metadata (raw)"
      trailing={`${keyCount} key${keyCount === 1 ? '' : 's'}`}
    >
      <p className="text-xs text-fg-muted">
        Full JSONB blob attached to this person. Edit-as-JSON is
        deliberately not surfaced; everything editable has its own panel.
      </p>
      <pre className="mt-3 overflow-x-auto rounded-md bg-surface-2 p-3 font-mono text-xs leading-relaxed text-fg-muted">
        {json}
      </pre>
    </CollapsibleSection>
  );
}
